import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import { frontendAccessRules } from "./accessRules";

const AdminPrivateRoute = () => {
  const { auth, loading } = useAuth();
  const location = useLocation();

  // console.log(`🔍 Checking AdminPrivateRoute for: ${location.pathname}`);
  // console.log(`👤 User Authenticated: ${auth.isAuthenticated}`);
  // console.log(`🔑 User Role: ${auth.user?.role}`);
  // console.log(`⏳ Loading state: ${loading}`);

  if (loading) {
    //console.log("⏳ Waiting for authentication to finish...");
    return null;
  }

  if (!auth.isAuthenticated) {
    console.log(`🚨 Not authenticated! Redirecting to /login`);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // ✅ Find the first matching route by prefix
  const matchedRule = Object.entries(frontendAccessRules).find(([path]) =>
    location.pathname.startsWith(path)
  );

  const allowedRoles = matchedRule ? matchedRule[1] : null;

  if (!allowedRoles) {
    console.log(`🚨 No access rules defined for ${location.pathname}. Blocking access.`);
    return <Navigate to="/" replace />;
  }

  if (!allowedRoles.includes(auth.user?.role)) {
    console.log(`❌ Access Denied for ${auth.user?.role} on ${location.pathname}. Redirecting.`);
    return <Navigate to="/" replace />;
  }

  //console.log(`✅ Admin Access Granted to ${location.pathname}`);
  return <Outlet />;
};

export default AdminPrivateRoute;
